export enum DeliveryPartner {
  UBER_EATS = "UberEats",
  DOOR_DASH = "DoorDash",
  POSTMATES = "Postmates",
  GRUB_HUB = "GrubHub",
}
